import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

export function splitByDefault(noticeId) {
  return request({
    url: urlPrefix + '/invoice/split-default',
    method: 'get',
    params: {noticeId: noticeId},
  });
}
export function splitByCostCenter(noticeId) {
  return request({
    url: urlPrefix + '/invoice/split-costcenter',
    method: 'get',
    params: {noticeId: noticeId},
  });
}
export function splitByHand(noticeId) {
  return request({
    url: urlPrefix + '/invoice/split-hand',
    method: 'get',
    params: {noticeId: noticeId},
  });
}

export function syInvoiceCiic(invoiceIds) {
  return request({
    url: urlPrefix + '/invoice/sync-invoice-ciic',
    method: 'get',
    params: {invoiceIds: invoiceIds},
  });
}
export function saveSplitInvoice(noticeId,createType,invoiceList) {
  return request({
    url: urlPrefix + '/invoice/save-split-invoice',
    method: 'post',
    data: {
      invoiceList:invoiceList,
      createType:createType,
      noticeId:noticeId,
    },
  });
}

//分页查询
export function getListpage(obj) {
  return request({
    url: urlPrefix + '/invoice/list-page',
    method: 'post',
    data: obj,
  });
}

export function getCusList() {
  return request({
    url: urlPrefix + '/invoice/cus-list',
    method: 'get',
  });
}
export function getInvoiceDetail(invoiceId) {
  return request({
    url: urlPrefix + '/invoice/invoice-detail',
    method: 'get',
    params: {invoiceId: invoiceId}
  });
}
export function getInvoiceItemList(cusId) {
  return request({
    url: urlPrefix + '/invoice/invoice-item-list',
    method: 'get',
    params: {cusId: cusId}
  });
}
export function getInvoiceTitleList(cusId) {
  return request({
    url: urlPrefix + '/invoice/invoice-title-list',
    method: 'get',
    params: {cusId: cusId}
  });
}
export function getOperateModeList(cusId) {
  return request({
    url: urlPrefix + '/invoice/operatemode-list',
    method: 'get',
    params: {cusId: cusId}
  });
}
export function getInvoiceAddrList(cusId,invoiceId) {
  return request({
    url: urlPrefix + '/invoice/mail-addr',
    method: 'get',
    params: {cusId: cusId,invoiceId:invoiceId}
  });
}
export function saveAddrInfo(obj) {
  return request({
    url: urlPrefix + '/invoice/save-addr',
    method: 'post',
    data: obj
  });
}
export function addHandInvoiceInfo(obj) {
  return request({
    url: urlPrefix + '/invoice/add-hand-invoice',
    method: 'post',
    data: obj
  });
}
export function mergeInvoice(obj) {
  return request({
    url: urlPrefix + '/invoice/merge-invoice',
    method: 'post',
    data: obj
  });
}
export function cancelMerge(invoiceId) {
  return request({
    url: urlPrefix + '/invoice/cancel-merge',
    method: 'get',
    params: {invoiceId:invoiceId}
  });
}
export function checkBorrowInvoice(obj) {
  return request({
    url: urlPrefix + '/invoice/check-borrow-invoice',
    method: 'post',
    data: obj
  });
}
export function borrowInvoice(applyInfo,invoiceIds) {
  return request({
    url: urlPrefix + '/invoice/save-borrow-invoice',
    method: 'post',
    data: {
      invoiceIds:invoiceIds,
      apply:applyInfo,
    }
  });
}

//批量删除发票
export function batchDeleteInvoice(obj) {
  return request({
    url: urlPrefix + '/invoice/batch-delete-invoice',
    method: 'delete',
    data: obj,
  });
}
export function sendInvoiceOms(obj) {
  return request({
    url: urlPrefix + '/invoice/send-invoice-oms',
    method: 'post',
    data: obj,
  });
}








